export const PREFIX = "kc";
export const NAME = "Kitchn";
